<template>
  <v-navigation-drawer
    app
    :value="value"
    @input="$emit('input', $event)"
    v-if="showSidebar"
  >
    <v-layout row>
      <v-img src="@/assets/logo.png" contain max-height="100"></v-img>
    </v-layout>

    <v-divider></v-divider>

    <v-list dense nav>
      <v-list-item
        v-for="link in links"
        :key="link.name"
        replace
        link
        :to="{ name: link.name }"
      >
        <v-list-item-icon>
          <v-icon>{{ link.meta.navbarIcon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ link.meta.navbarTitle }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div v-if="this.userRole == 'SEC'">
      <v-divider></v-divider>
      <v-subheader>Admin</v-subheader>
      <v-list dense nav>
        <v-list-item
          v-for="link in sLinks"
          :key="link.name"
          link
          :to="{ name: link.name }"
        >
          <v-list-item-icon>
            <v-icon>{{ link.meta.navbarIcon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ link.meta.navbarTitle }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <div v-if="isAdmin">
      <v-divider></v-divider>
      <v-subheader>Admin</v-subheader>
      <v-list dense nav>
        <v-list-item
          v-for="link in aLinks"
          :key="link.name"
          link
          :to="{ name: link.name }"
        >
          <v-list-item-icon>
            <v-icon>{{ link.meta.navbarIcon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ link.meta.navbarTitle }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import appRoutes from "@/routes/app-routes";
import adminRoutes from "@/routes/admin-routes";
import securityRoutes from "@/routes/security-routes";

export default {
  name: "Sidebar",
  props: ["value"],
  data() {
    return {
      links: appRoutes,
      aLinks: adminRoutes,
      sLinks: securityRoutes,
      isAdmin: false,
      userRole: ""
    };
  },
  async created() {
    await this.getPermission();
  },
  methods: {
    async getPermission() {
      this.userRole = this.$store.state.user.role;
      this.isAdmin = this.userRole === "ADM";
    }
  },
  computed: {
    showSidebar() {
      return this.userRole != "PER";
    },
    allowedLinks() {
      return this.links.filter(link => {
        return link.requiresAuth.some(a => a === this.userRole);
      });
    }
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
